import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private data = new BehaviorSubject<any>('filter changed');
  private subject = new BehaviorSubject<any>('subject changed');
  private searchResult = new BehaviorSubject<any>('search result');

  public data$ = this.data.asObservable();
  public subject$ = this.subject.asObservable();
  public searchResult$ = this.searchResult.asObservable();

  constructor() {}

  globalFilterChange(msg: any) {
    this.data.next(msg);
  }

  sendSubject(msg: any) {
      this.subject.next(msg);
  }

  sendMessageForShowingResults(msg: any) {
    this.searchResult.next(msg);
  }
}
